<form class="organisation-info-edit" [formGroup]="infoForm">
  <div class="organisation-info-edit__basic">
    <app-photo
      class="image"
      [mode]="'edit'"
      [type]="'photo'"
      [id]="data?.photoId"
      [height]="isLargeScreen ? '144px' : '96px'"
      [width]="isLargeScreen ? '144px' : '96px'"
      [borderRadius]="isLargeScreen ? '144px' : '96px'"
      [rounded]="true"
      [loading]="!!loading"
      (photoChange)="onPhotoChange($event)"
    ></app-photo>

    <tui-input
      tuiAutoFocus
      class="field"
      tabindex="1"
      formControlName="fullName"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ 'components.organisationInfo.fields.fullName' | translate }}
      <span class="tui-required"></span>
    </tui-input>

    <tui-input
      class="field"
      tabindex="2"
      formControlName="shortName"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ 'components.organisationInfo.fields.shortName' | translate }}
      <span class="tui-required"></span>
    </tui-input>

    <tui-input-number
      *ngIf="!data?.parentOrganisation"
      class="field"
      tabindex="3"
      formControlName="numberOfOrganisations"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [min]="1"
    >
      {{ 'components.organisationInfo.fields.numberOfOrganisations' | translate }}
    </tui-input-number>
  </div>

  <div class="organisation-info-edit__extended">
    <tui-select
      class="field"
      tabindex="4"
      formControlName="opfTypeId"
      [valueContent]="opfTypes ? opfTypesStringify(opfTypes) : ''"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldCleaner]="true"
    >
      {{ 'components.organisationInfo.fields.opfType' | translate }}
      <tui-data-list *tuiDataList>
        <button *ngFor="let opfType of opfTypes" tuiOption [value]="opfType.id">
          {{ opfType.name }}
        </button>
      </tui-data-list>
    </tui-select>

    <tui-input
      class="field"
      tabindex="5"
      formControlName="addressPhysical"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ 'components.organisationInfo.fields.addressPhysical' | translate }}
    </tui-input>

    <tui-input
      class="field"
      tabindex="6"
      formControlName="addressLegal"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ 'components.organisationInfo.fields.addressLegal' | translate }}
    </tui-input>

    <tui-multi-select
      *ngIf="allowSpecialFieldsEditing"
      class="field"
      tabindex="7"
      formControlName="businessTypes"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [tuiTextfieldCleaner]="true"
      [editable]="false"
      [stringify]="stringifyBusinessTypes"
    >
      {{ 'components.organisationInfo.fields.businessTypes' | translate }}
      <tui-data-list *tuiDataList tuiMultiSelectGroup>
        <button *ngFor="let businessType of businessTypes" tuiOption [value]="businessType">
          {{ businessType.businessTypeName }}
        </button>
      </tui-data-list>
    </tui-multi-select>

    <tui-input-date
      *ngIf="data?.parentOrganisation && allowSpecialFieldsForAssociationEditing"
      class="field"
      tabindex="8"
      formControlName="membershipPaidTill"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.organisationInfo.fields.membershipPaidTill' | translate }}
    </tui-input-date>

    <ng-container *ngIf="!infoForm.get('oldCard')?.value">
      <app-input-files
        class="field size_{{ tuiElementLargeSize }}"
        tabindex="9"
        formControlName="card"
        accept=".pdf, .doc, .docx, .rtf"
        [maxFileSize]="maxDocFileSize"
        [link]="'components.organisationInfo.fields.uploadCard' | translate"
        [label]="' '"
        [size]="tuiElementLargeSize"
        [loading]="!!loading"
      ></app-input-files>
    </ng-container>
    <ng-container *ngIf="!!infoForm.get('oldCard')?.value">
      <app-input-files
        class="field size_{{ tuiElementLargeSize }}"
        tabindex="9"
        formControlName="oldCard"
        accept=".pdf, .doc, .docx, .rtf"
        [maxFileSize]="maxDocFileSize"
        [link]="'components.organisationInfo.fields.uploadCard' | translate"
        [label]="' '"
        [size]="tuiElementLargeSize"
        [loading]="!!loading"
      ></app-input-files>
    </ng-container>

    <ng-container
      *ngIf="!infoForm.value.oldInvoice && data?.parentOrganisation && allowSpecialFieldsForAssociationEditing"
    >
      <app-input-files
        class="field size_{{ tuiElementLargeSize }}"
        tabindex="10"
        formControlName="invoice"
        [maxFileSize]="maxDocFileSize"
        [link]="'components.organisationInfo.fields.uploadInvoice' | translate"
        [label]="' '"
        [size]="tuiElementLargeSize"
        [loading]="!!loading"
      ></app-input-files>
    </ng-container>
    <ng-container
      *ngIf="!!infoForm.value.oldInvoice && !!data?.parentOrganisation && allowSpecialFieldsForAssociationEditing"
    >
      <app-input-files
        class="field size_{{ tuiElementLargeSize }}"
        tabindex="10"
        formControlName="oldInvoice"
        [maxFileSize]="maxDocFileSize"
        [link]="'components.organisationInfo.fields.uploadInvoice' | translate"
        [label]="' '"
        [size]="tuiElementLargeSize"
        [loading]="!!loading"
      ></app-input-files>
    </ng-container>
  </div>

  <app-contacts
    class="organisation-info-edit__contacts"
    formControlName="contacts"
    [allowCreating]="true"
    [allowEditing]="true"
    [allowDeleting]="true"
    [loading]="!!loading"
  ></app-contacts>

  <div *ngIf="!loading && allowEditing" class="organisation-info-edit__buttons">
    <button
      tuiButton
      class="organisation-info-edit-button organisation-info-edit-button_edit"
      tabindex="19"
      type="button"
      [appearance]="'primary'"
      [size]="tuiElementLargeSize"
      (click)="onClickSaveButton()"
    >
      {{ 'common.buttons.save' | translate }}
    </button>
    <button
      tuiButton
      class="organisation-info-edit-button organisation-info-edit-button_cancel"
      tabindex="20"
      type="button"
      [appearance]="'secondary'"
      [size]="tuiElementLargeSize"
      (click)="onClickCancelButton()"
    >
      {{ 'common.buttons.cancel' | translate }}
    </button>
  </div>
</form>
